// Footer accordion functionality for mobile
function initFooterAccordion() {
  const footerCells = document.querySelectorAll('.footer-cell');

  footerCells.forEach(cell => {
    const title = cell.querySelector('.footer-cell-title');

    if (title) {
      title.addEventListener('click', function() {
        // Check if we're below lg breakpoint (992px)
        if (window.innerWidth < 992) {
          cell.classList.toggle('footer-cell--open');
        }
      });
    }
  });
}

// Initialize Bootstrap tooltips
function initTooltips() {
  const tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
  );
  tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
  });
}

// Filters panel slide functionality
function initFiltersPanel() {
  const toggleBtn = document.querySelector('.filters-toggle-btn');
  const closeBtn = document.querySelector('.filters-close-btn');
  const aside = document.querySelector('.filters-aside');
  const overlay = document.querySelector('.filters-overlay');

  if (!toggleBtn || !aside) return;

  function openFilters() {
    aside.classList.add('filters-aside--open');
    if (overlay) overlay.classList.add('filters-overlay--open');
    document.body.style.overflow = 'hidden';
  }

  function closeFilters() {
    aside.classList.remove('filters-aside--open');
    if (overlay) overlay.classList.remove('filters-overlay--open');
    document.body.style.overflow = '';
  }

  toggleBtn.addEventListener('click', openFilters);

  if (closeBtn) {
    closeBtn.addEventListener('click', closeFilters);
  }

  if (overlay) {
    overlay.addEventListener('click', closeFilters);
  }

  // Close on ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && aside.classList.contains('filters-aside--open')) {
      closeFilters();
    }
  });

  // Close if window resizes above 1280px
  window.addEventListener('resize', function() {
    if (window.innerWidth >= 1280) {
      closeFilters();
    }
  });
}

// Read more functionality
function initReadMore() {
  const readMoreBtns = document.querySelectorAll('.btn-read-more');

  readMoreBtns.forEach(btn => {
    const wrapper = btn.closest('.tab-content-wrapper');
    const content = wrapper.querySelector('.tab-content-truncated');
    const btnText = btn.querySelector('span');

    // Check if content overflows (240px is the max-height from CSS)
    if (content.scrollHeight <= 240) {
      btn.style.display = 'none';
      content.classList.add('no-overflow');
      return;
    }

    btn.addEventListener('click', function() {
      content.classList.toggle('expanded');
      this.classList.toggle('expanded');

      if (content.classList.contains('expanded')) {
        btnText.textContent = this.getAttribute('data-text-less');
      } else {
        btnText.textContent = this.getAttribute('data-text-more');
      }
    });
  });
}

// Position sidebar to align with pad-detail-page-content
function initSidebarPosition() {
  const sidebar = document.querySelector('.pad-detail-sidebar');
  const content = document.querySelector('.pad-detail-page-content');
  const footer = document.querySelector('.footer');

  if (!sidebar || !content || !footer || !sidebar.offsetParent) return;

  const contentTop = content.getBoundingClientRect().top + window.scrollY;
  const parentTop = sidebar.offsetParent.getBoundingClientRect().top + window.scrollY;
  const footerTop = footer.getBoundingClientRect().top + window.scrollY;

  const sidebarTop = contentTop - parentTop;
  const sidebarHeight = footerTop - contentTop;

  sidebar.style.top = sidebarTop + 'px';
  sidebar.style.height = sidebarHeight + 'px';
}

// Custom file input - update text when file is selected
function initCustomFileInput() {
  const fileWrappers = document.querySelectorAll('.custom-file-input');

  fileWrappers.forEach(wrapper => {
    const input = wrapper.querySelector('input[type="file"]');
    const labelText = wrapper.querySelector('.custom-file-label-text');
    const clearBtn = wrapper.querySelector('.custom-file-clear');
    const defaultText = labelText?.getAttribute('data-default-text') || 'Niciun fișier selectat';

    if (!input || !labelText) return;

    input.addEventListener('change', function() {
      if (this.files.length > 0) {
        labelText.textContent = this.files[0].name;
        wrapper.classList.add('has-file');
      } else {
        labelText.textContent = defaultText;
        wrapper.classList.remove('has-file');
      }
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        input.value = '';
        labelText.textContent = defaultText;
        wrapper.classList.remove('has-file');
      });
    }
  });
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', function() {
  initFooterAccordion();
  initTooltips();
  initFiltersPanel();
  initReadMore();
  initSidebarPosition();
  initCustomFileInput();
});
